// Blog posts data and utility functions

const blogPosts = [
  {
    id: 1,
    slug: 'we-got-into-start2grow',
    type: 'internal',
    title: {
      en: 'We got into start2grow',
      de: 'Wir sind bei start2grow dabei'
    },
    date: '2025-02-10',
    image: 'start2grow.png',
    excerpt: {
      en: 'We\'ve been invited to the start2grow finals to pitch Thinki in Dortmund.',
      de: 'Wir wurden eingeladen, beim start2grow Finale Thinki in Dortmund zu präsentieren.'
    },
    content: {
      en: `Hello, we are very excited to announce that we have been invited to the finals of the startup competition start2grow as one of the top 20 teams!

‍https://lnkd.in/d7vd7FF

‍A huge thank you to the organizing team for this fantastic opportunity.
The pitch will take place on February 26 in Dortmund, where we will present our vision of Thinki, the all-in-one AI companion for students, to the jury.
Thank you to everyone who has supported us along the way.`,
      de: `Hallo, wir freuen uns sehr bekannt zu geben, dass wir als eines der Top-20-Teams zum Finale des Startup-Wettbewerbs start2grow eingeladen wurden!

‍https://lnkd.in/d7vd7FF

‍Ein großes Dankeschön an das Organisationsteam für diese fantastische Gelegenheit.
Der Pitch findet am 26. Februar in Dortmund statt, wo wir unsere Vision von Thinki, dem All-in-One-KI-Begleiter für Studierende, der Jury präsentieren werden.
Vielen Dank an alle, die uns auf diesem Weg unterstützt haben.`
    },
    externalUrl: null,
    tags: ['Update'],
    category: 'company-news',
    published: true,
    language: 'en'
  },
  {
    id: 2,
    slug: 'microsoft-for-startups-founders-program',
    type: 'internal',
    title: {
      en: 'We got accepted to the Microsoft for Startups Founders Program!',
      de: 'Wir wurden ins Microsoft for Startups Founders Program aufgenommen!'
    },
    date: '2024-07-17',
    image: 'microsoft-startups.png',
    excerpt: {
      en: 'Plix AI has been accepted into the Microsoft for Startups Founders Program.',
      de: 'Plix AI wurde in das Microsoft for Startups Founders Program aufgenommen.'
    },
    content: {
      en: `Great news! Plix AI has been accepted into the Microsoft for Startups Founders Program. Through this program, we'll gain access to a lot of resources and support from Microsoft, including up to $150,000 in Azure credits, technical support, and mentorship from industry experts as well as credits for OpenAI, Github, and many other offers.

We want to extend a big thank you to the Microsoft for Startups team for this great opportunity and easy application process.`,
      de: `Großartige Neuigkeiten! Plix AI wurde in das Microsoft for Startups Founders Program aufgenommen. Durch dieses Programm erhalten wir Zugang zu vielen Ressourcen und Unterstützung von Microsoft, darunter bis zu 150.000 $ an Azure-Guthaben, technischen Support und Mentoring von Branchenexperten sowie Guthaben für OpenAI, Github und viele weitere Angebote.

Wir möchten dem Microsoft for Startups-Team für diese großartige Gelegenheit und den unkomplizierten Bewerbungsprozess herzlich danken.`
    },
    externalUrl: null,
    tags: ['Partnership'],
    category: 'company-news',
    published: true,
    language: 'en'
  },
  {
    id: 3,
    slug: 'fiarra-invited-to-dpwk-ai-panel',
    type: 'internal',
    title: {
      en: 'Fiarra invited to DPWK AI Panel',
      de: 'Fiarra zum DPWK AI Panel eingeladen'
    },
    date: '2024-07-10',
    image: 'dpwk-panel.png',
    excerpt: {
      en: 'Fiarra joins the DPWK AI Panel to discuss AI\'s impact on education and communication.',
      de: 'Fiarra nimmt am DPWK AI Panel teil, um über KI-Einfluss auf Bildung und Kommunikation zu diskutieren.'
    },
    content: {
      en: `Fiarra has been invited to be part of the DPWK AI Panel in Berlin together HTW Berlin president Prof. Dr. Annabella Rauscher-Scheibe, and the Forbes-listed AI expert Sebastian Moritz! They'll discuss the current impact and future possibilities of AI in education and communication.

The 23rd DPWK will be awarded by Business Communication students. Awards will be given in seven categories, recognizing both large global brands and smaller, medium-sized firms for their outstanding communication campaigns.

Here are the details:

Date and Time: Thursday, July 11, 2024. The panel starts at 19:00 with the AI discussion scheduled for the evening.
Location: VON GREIFSWALD, Lilli-Henoch-Straße 10, 10405 Berlin.
Agenda: The event kicks off at 18:00 with entry, followed by the award ceremony and keynote speeches. The AI Panel discussion, featuring Fiarra, will explore the opportunities and challenges AI presents for education and beyond.
After the discussions, there will be a networking session starting at 20:45, where attendees can engage over food and drinks, discussing key topics affecting the communication industry.`,
      de: `Fiarra wurde eingeladen, Teil des DPWK AI Panels in Berlin zu sein, gemeinsam mit der HTW Berlin-Präsidentin Prof. Dr. Annabella Rauscher-Scheibe und dem Forbes-gelisteten KI-Experten Sebastian Moritz! Dort werden sie über die aktuellen Auswirkungen und zukünftigen Möglichkeiten von KI in Bildung und Kommunikation diskutieren.

Der 23. DPWK wird von Studierenden der Wirtschaftskommunikation verliehen. Preise werden in sieben Kategorien vergeben und würdigen sowohl große globale Marken als auch kleinere und mittlere Unternehmen für ihre herausragenden Kommunikationskampagnen.

Hier sind die Details:

Datum und Uhrzeit: Donnerstag, 11. Juli 2024. Das Panel beginnt um 19:00 Uhr mit der KI-Diskussion am Abend.
Ort: VON GREIFSWALD, Lilli-Henoch-Straße 10, 10405 Berlin.
Agenda: Die Veranstaltung beginnt um 18:00 Uhr mit Einlass, gefolgt von der Preisverleihung und Keynote-Reden. Die KI-Panel-Diskussion mit Fiarra wird die Chancen und Herausforderungen untersuchen, die KI für die Bildung und darüber hinaus bietet.
Nach den Diskussionen gibt es ab 20:45 Uhr eine Networking-Session, bei der ihr euch bei Essen und Getränken über wichtige Themen der Kommunikationsbranche austauschen könnt.`
    },
    externalUrl: null,
    tags: ['Event'],
    category: 'company-news',
    published: true,
    language: 'en'
  },
  {
    id: 4,
    slug: 'thinki-online-for-beta-users',
    type: 'internal',
    title: {
      en: 'Thinki is now online and available for our Beta users',
      de: 'Thinki ist jetzt online und für unsere Beta-Nutzer verfügbar'
    },
    date: '2024-07-09',
    image: 'thinki-beta.png',
    excerpt: {
      en: 'After months of development, Thinki is now live for beta testing.',
      de: 'Nach Monaten der Entwicklung ist Thinki jetzt live für Beta-Tests.'
    },
    content: {
      en: `Great news! After several months of coding, some tears and frustrations and a lot of Stackoverflow and ChatGPT support, Thinki is up and running for beta testing and we are onboarding our first test group this month.
We have decided on our first group already, but if you are interested and want to participate, send us an email at info@thinki.de.`,
      de: `Große Neuigkeiten! Nach mehreren Monaten des Programmierens, einigen Tränen und Frustrationen und viel Unterstützung von Stackoverflow und ChatGPT, läuft Thinki nun für Beta-Tests und wir nehmen unsere erste Testgruppe diesen Monat auf.
Wir haben uns bereits für unsere erste Gruppe entschieden, aber wenn du interessiert bist und teilnehmen möchtest, schick uns eine E-Mail an info@thinki.de.`
    },
    externalUrl: null,
    tags: ['Product'],
    category: 'company-news',
    published: true,
    language: 'en'
  },
  {
    id: 5,
    slug: 'ibb-coaching-bonus',
    type: 'internal',
    title: {
      en: 'We got accepted to the IBB Coaching Bonus',
      de: 'Wir wurden für den IBB Coaching Bonus angenommen'
    },
    date: '2024-07-03',
    image: 'ibb-coaching.png',
    excerpt: {
      en: 'We\'ve been accepted to the IBB Coaching Bonus program for startup support.',
      de: 'Wir wurden in das IBB Coaching Bonus Programm zur Startup-Förderung aufgenommen.'
    },
    content: {
      en: `Plix AI Receives IBB Coaching Bonus

We've been accepted to the IBB Coaching Bonus program! This means we will receive the support of a Coach for the next several months. We are very thankful to the IBB Coaching Bonus team and are looking forward to working with our coach, who will help us figure out our next steps, when and where to apply for funding as well as improving on our business plan and pricing strategy. Also, thanks a lot to our tax attorney who gave us the tip.`,
      de: `Plix AI erhält IBB Coaching Bonus

Wir wurden für das IBB Coaching Bonus Programm angenommen! Das bedeutet, dass wir in den nächsten Monaten die Unterstützung eines Coaches erhalten werden. Wir sind dem IBB Coaching Bonus-Team sehr dankbar und freuen uns auf die Zusammenarbeit mit unserem Coach, der uns bei unseren nächsten Schritten hilft, wann und wo wir Förderungen beantragen sollten sowie bei der Verbesserung unseres Businessplans und unserer Preisstrategie. Außerdem vielen Dank an unseren Steuerberater, der uns den Tipp gegeben hat.`
    },
    externalUrl: null,
    tags: ['Funding'],
    category: 'company-news',
    published: true,
    language: 'en'
  },
  {
    id: 6,
    slug: 'plix-ai-founded',
    type: 'internal',
    title: {
      en: 'Plix AI i. G. has been founded',
      de: 'Plix AI i. G. wurde gegründet'
    },
    date: '2024-06-13',
    image: 'plix-founded.png',
    excerpt: {
      en: 'Plix AI is now officially founded as a GmbH i. G.',
      de: 'Plix AI ist jetzt offiziell als GmbH i. G. gegründet.'
    },
    content: {
      en: `Plix AI is now officially a GmbH i. G. This means we've completed all of the paperwork and are ready to get to work.‍

What We Do

‍We're here to develop straightforward AI solutions for education. Our goal is to create tools that use the most recent AI models, are easy to use and really solve problems.

What's Coming Up?

‍With our official status close to locked down, we're focusing on building out our first AI education app, "Thinki". We'll keep you updated right here with all the latest developments and occasionally share behind-the-scenes looks at our process.

Send us a message

‍We are just starting out and between running a business and coding we can use all the help and advice we can get. So we'd love to have you along for the ride. If you want to help us improve Thinki, know an accelerator we should apply to, are a VC interested in investing, or even want to come work with us, let us know. We will appreciate it!

Watch this space for regular updates, and feel free to drop us a line anytime if you've got questions or just want to chat about AI.

Stay tuned!`,
      de: `Plix AI ist jetzt offiziell eine GmbH i. G. Das bedeutet, dass wir alle Formalitäten erledigt haben und bereit sind, loszulegen.‍

Was wir tun

‍Wir sind hier, um unkomplizierte KI-Lösungen für die Bildung zu entwickeln. Unser Ziel ist es, Tools zu erstellen, die die neuesten KI-Modelle nutzen, einfach zu bedienen sind und wirklich Probleme lösen.

Was kommt als Nächstes?

‍Mit unserem offiziellen Status fast abgesichert, konzentrieren wir uns auf den Aufbau unserer ersten KI-Bildungs-App „Thinki". Wir werden euch hier mit allen neuesten Entwicklungen auf dem Laufenden halten und gelegentlich Einblicke hinter die Kulissen unseres Prozesses teilen.

Schreib uns eine Nachricht

‍Wir fangen gerade erst an, und zwischen der Führung eines Unternehmens und dem Programmieren können wir jede Hilfe und jeden Rat gebrauchen. Wir würden uns freuen, euch auf dieser Reise dabei zu haben. Wenn du uns helfen möchtest, Thinki zu verbessern, einen Accelerator kennst, bei dem wir uns bewerben sollten, ein VC bist, der an Investitionen interessiert ist, oder sogar mit uns arbeiten möchtest, lass es uns wissen. Wir werden es sehr zu schätzen wissen!

Schau für regelmäßige Updates hier vorbei und zögere nicht, uns jederzeit zu kontaktieren, wenn du Fragen hast oder einfach über KI sprechen möchtest.

Bleibt dran!`
    },
    externalUrl: null,
    tags: ['Update'],
    category: 'company-news',
    published: true,
    language: 'en'
  },
  {
    id: 7,
    slug: 'ihk-berlin-festival-2025',
    type: 'linkedin',
    title: {
      en: 'Berlin Business Festival - IHK Berlin',
      de: 'Festival der Berliner Wirtschaft - IHK Berlin'
    },
    date: '2025-09-15',
    image: 'ihk-festival-2025.jpeg',
    excerpt: {
      en: 'We attended the Berlin Business Festival and learned about AI applications.',
      de: 'Wir waren beim Festival der Berliner Wirtschaft und haben viel über KI-Anwendungen gelernt.'
    },
    content: null,
    externalUrl: 'https://www.linkedin.com/posts/plix-ai_ihkberlin-innovation-textanalyseki-activity-7373305342052425728-lkEH',
    tags: ['Event'],
    category: 'company-news',
    published: true,
    language: 'de'
  },
  {
    id: 8,
    slug: 'fiarra-dgpuk-methoden25',
    type: 'linkedin',
    title: {
      en: 'Fiarra presents at DGPuK Methoden25 Conference',
      de: 'Fiarra präsentiert auf der DGPuK Methoden25 Konferenz'
    },
    date: '2025-10-02',
    image: 'fiarra-dgpuk-2025.jpeg',
    excerpt: {
      en: 'Fiarra presents research on evaluating LLMs for systematic reviews at Methoden25.',
      de: 'Fiarra präsentiert Forschung zur Bewertung von LLMs für systematische Reviews bei Methoden25.'
    },
    content: null,
    externalUrl: 'https://www.linkedin.com/posts/fiarra-pohling_methoden25-dgpuk-computationalsocialsciences-activity-7379414980162506753-_KuK',
    tags: ['Paper'],
    category: 'company-news',
    published: true,
    language: 'en'
  }
];

// Get all published blog posts, sorted by date (newest first)
export const getAllPosts = () => {
  return [...blogPosts]
    .filter(post => post.published)
    .sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });
};

// Get a post by slug
export const getPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
}; 